export default __webpack_public_path__ + "b4c2832c2524130fa8933959bc2cf8ef.png";